import React from 'react';
import { GridLoader} from 'react-spinners';

const LoadingSpinner = () => {
  return (
    <div className="spinner-container">
      <GridLoader color="#28a745" />
    </div>
  );
};

export default LoadingSpinner;
